module.exports = __webpack_public_path__ + "static/media/card_3.8bd029cb.png";